import { motion } from 'framer-motion'
import SEO from '../components/SEO'
import ImageCropper from '../components/ImageCropper'
import { useIntl } from 'react-intl'

const Cropper = () => {
  const intl = useIntl()
  
  const handleCropComplete = (croppedImageUrl: string) => {
    console.log('Cropped image URL:', croppedImageUrl)
    // You can add additional logic here, such as saving to local storage
    // or showing a success message
  }

  return (
    <>
      <SEO
        title={intl.formatMessage({ id: 'cropper.title' })}
        description={intl.formatMessage({ id: 'cropper.description' })}
        keywords={intl.formatMessage({ id: 'cropper.keywords' })}
      />
      
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 pt-32 pb-8"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="mb-8"
          >
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              {intl.formatMessage({ id: 'cropper.mainTitle' })}
            </h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              {intl.formatMessage({ id: 'cropper.mainDescription' })}
            </p>
          </motion.div>

          {/* Main Cropper Component */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <ImageCropper onCropComplete={handleCropComplete} />
          </motion.div>

          {/* Features Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6"
          >
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {intl.formatMessage({ id: 'cropper.features.platformOptimized.title' })}
              </h3>
              <p className="text-gray-600">
                {intl.formatMessage({ id: 'cropper.features.platformOptimized.description' })}
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {intl.formatMessage({ id: 'cropper.features.advancedTool.title' })}
              </h3>
              <p className="text-gray-600">
                {intl.formatMessage({ id: 'cropper.features.advancedTool.description' })}
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {intl.formatMessage({ id: 'cropper.features.highQuality.title' })}
              </h3>
              <p className="text-gray-600">
                {intl.formatMessage({ id: 'cropper.features.highQuality.description' })}
              </p>
            </div>
          </motion.div>

          {/* Tips Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="mt-12 bg-primary-50 rounded-xl p-6"
          >
            <h3 className="text-lg font-semibold text-primary-900 mb-4">
              {intl.formatMessage({ id: 'cropper.tips.title' })}
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-primary-800">
              <div>
                <h4 className="font-medium mb-1">
                  {intl.formatMessage({ id: 'cropper.tips.imageQuality.title' })}
                </h4>
                <p>{intl.formatMessage({ id: 'cropper.tips.imageQuality.description' })}</p>
              </div>
              <div>
                <h4 className="font-medium mb-1">
                  {intl.formatMessage({ id: 'cropper.tips.lighting.title' })}
                </h4>
                <p>{intl.formatMessage({ id: 'cropper.tips.lighting.description' })}</p>
              </div>
              <div>
                <h4 className="font-medium mb-1">
                  {intl.formatMessage({ id: 'cropper.tips.composition.title' })}
                </h4>
                <p>{intl.formatMessage({ id: 'cropper.tips.composition.description' })}</p>
              </div>
              <div>
                <h4 className="font-medium mb-1">
                  {intl.formatMessage({ id: 'cropper.tips.fileFormat.title' })}
                </h4>
                <p>{intl.formatMessage({ id: 'cropper.tips.fileFormat.description' })}</p>
              </div>
            </div>
          </motion.div>
        </div>
      </motion.div>
    </>
  )
}

export default Cropper